import { Route, Switch } from "react-router-dom";
import CalendarioDepositosListagemPage from "./Listagem";

function CalendarioDepositosPages() {
  return (
    <Switch>
      <Route
        exact
        path="/financeiro/calendario-depositos"
        component={CalendarioDepositosListagemPage}
      />
    </Switch>
  );
}

export default CalendarioDepositosPages;
